const prefix = 'user/'

const type = {
    GET_LIST_USERS: prefix + 'get_list_users',
    GET_LIST_USERS_SUCCESS: prefix + 'get_list_users_success',
    PRE_ADD_USER: prefix + 'pre_add_user',
    SET_INIT_STATE: prefix + 'set_init_state',

    UPDATE_CURRENT_USER: prefix + 'update_current_user',
    RESET_PASSWORD_USER: prefix + 'reset_password_user',
    SAVE_CURRENT_USER: prefix + 'save_current_user',
    DELETE_USER: prefix + 'delete_user',
    BAN_USER: prefix + 'ban_user',
    GET_CURRENT_USER: prefix + 'get_current_user',
    UPDATE_STATE: prefix + 'update_state',
    UPDATE_AVATAR_FILE: prefix + 'update_avatar_file',

    CHANGE_NUMBER_OF_PAGE: prefix + 'change_number_of_page',
    CHANGE_CURRENT_PAGE: prefix + 'change_current_page',

    SHOW_MODAL_CURRENT_USER_INFO: prefix + 'show_modal_current_user_info',
    DISMISS_MODAL_CURRENT_USER_INFO: prefix + 'dismiss_modal_current_user_info',
    SHOW_MODAL_CONFIRM_DELETE_USER: prefix + 'show_modal_confirm_delete_user',
    DISMISS_MODAL_CONFIRM_DELETE_USER:
        prefix + 'dismiss_modal_confirm_delete_user',
    SHOW_MODAL_CONFIRM_BAN_USER: prefix + 'show_modal_confirm_ban_user',
    DISMISS_MODAL_CONFIRM_BAN_USER: prefix + 'dismiss_modal_confirm_ban_user',
    SHOW_MODAL_RESET_PASSWORD: prefix + 'show_modal_reset_password',
    DISMISSS_MODAL_RESET_PASSWORD: prefix + 'dismiss_modal_reset_password',

    GET_LIST_ROLES: prefix + 'get_list_role',
    GET_LIST_ROLES_SUCCESS: prefix + 'get_list_role_success',

    UPDATE_TEXT_SEARCH: prefix + 'update_text_search',
    SEARCH_USER: prefix + 'search_user',
    ADD_NEW_USER: prefix + 'ADD_NEW_USER',
}

const action = {
    addNewUserState: bool => {
        return {
            type: type.ADD_NEW_USER,
            payload: {
                bool,
            },
        }
    },
    getListUsers: params => {
        return {
            type: type.GET_LIST_USERS,
            payload: {
                params,
            },
        }
    },
    getListUsersSuccess: (users, lastId) => {
        return {
            type: type.GET_LIST_USERS_SUCCESS,
            payload: {
                users,
            },
        }
    },
    preAddUser: () => {
        return {
            type: type.PRE_ADD_USER,
            payload: {},
        }
    },
    setInitState: () => {
        return {
            type: type.SET_INIT_STATE,
            payload: {
                
            }
        }
    },
    updateCurrentUser: user => {
        return {
            type: type.UPDATE_CURRENT_USER,
            payload: {
                user,
            },
        }
    },
    saveCurrentUser: () => {
        return {
            type: type.SAVE_CURRENT_USER,
            payload: {},
        }
    },
    deleteUser: userId => {
        return {
            type: type.DELETE_USER,
            payload: {
                userId,
            },
        }
    },
    banUser: userId => {
        return {
            type: type.BAN_USER,
            payload: {
                userId,
            },
        }
    },
    getCurrentUser: userId => {
        return {
            type: type.GET_CURRENT_USER,
            payload: {
                userId,
            },
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state,
            },
        }
    },
    showModalCurrentUserInfo: () => {
        return {
            type: type.SHOW_MODAL_CURRENT_USER_INFO,
            payload: {},
        }
    },
    dismissModalCurrentUserInfo: () => {
        return {
            type: type.DISMISS_MODAL_CURRENT_USER_INFO,
            payload: {},
        }
    },
    showModalConfirmDelteUser: () => {
        return {
            type: type.SHOW_MODAL_CONFIRM_DELETE_USER,
            payload: {},
        }
    },
    dismissModalConfirmDeleteUser: () => {
        return {
            type: type.DISMISS_MODAL_CONFIRM_DELETE_USER,
            payload: {},
        }
    },
    showModalConfirmBanUser: () => {
        return {
            type: type.SHOW_MODAL_CONFIRM_BAN_USER,
            payload: {},
        }
    },
    dismissModalConfirmBanUser: () => {
        return {
            type: type.DISMISS_MODAL_CONFIRM_BAN_USER,
            payload: {},
        }
    },
    updateAvatarFile: file => {
        return {
            type: type.UPDATE_AVATAR_FILE,
            payload: {
                file,
            },
        }
    },

    changeNumberOfPage: numberOfPage => {
        return {
            type: type.CHANGE_NUMBER_OF_PAGE,
            payload: {
                numberOfPage,
            },
        }
    },
    changeCurrentPage: pageIndex => {
        return {
            type: type.CHANGE_CURRENT_PAGE,
            payload: {
                pageIndex,
            },
        }
    },
    getListRole: () => {
        return {
            type: type.GET_LIST_ROLES,
            payload: {},
        }
    },
    getListRolesSuccess: roles => {
        return {
            type: type.GET_LIST_ROLES_SUCCESS,
            payload: {
                roles,
            },
        }
    },
    showModalResetPassword: () => {
        return {
            type: type.SHOW_MODAL_RESET_PASSWORD,
            payload: {},
        }
    },
    dismissModalResetPassword: () => {
        return {
            type: type.DISMISSS_MODAL_RESET_PASSWORD,
            payload: {},
        }
    },
    resetPasswordUser: (user, newPassword) => {
        return {
            type: type.RESET_PASSWORD_USER,
            payload: {
                user,
                newPassword,
            },
        }
    },
    updateTextSearch: textSearch => {
        return {
            type: type.UPDATE_TEXT_SEARCH,
            payload: {
                textSearch,
            },
        }
    },
    searchUser: () => {
        return {
            type: type.SEARCH_USER,
            payload: {},
        }
    },
}

export default {
    type,
    action,
}
